// extracted by mini-css-extract-plugin
export default {"melodyVideo":"WK-z","isFullWidth":"XK-z","landingPageVideo":"YK-z","play":"ZK-z","iframeVideo":"_K-z","playHidden":"aL-z","fullwidth":"bL-z"};